export default __webpack_public_path__ + "static/media/phLogoBrownBorder.5941d934.svg";